import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';
import { HiMenu, HiX } from 'react-icons/hi';
import { Phone, CreditCard, History, CircleUserRound, Mail, MessageCircle, Globe } from 'lucide-react'

const Navbar = () => {
  const { token } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => setMenuOpen(prev => !prev);

  return (
    <nav className="sticky top-0 z-50 w-full px-4 py-3 bg-white">
      <div className="flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <img
            src="/dialvia-logo-min.webp"
            alt="DialVia Logo"
            className="w-8 h-8 rounded-full object-cover"
            height="32px"
            width="32px"
          />
          <Link to="/" className="text-lg font-semibold text-gray-900">
            DialVia
          </Link>
        </div>

        {/* Center: Desktop nav */}
        <div className="hidden lg:flex space-x-6 text-gray-900 font-medium">
          <Link to="/call" className="hover:text-gray-500 transition flex items-center gap-1.5">
            <Phone className="w-4 h-4" />
            Call
          </Link>
          <Link to="/buy-credits" className="hover:text-gray-500 transition flex items-center gap-1.5">
            <CreditCard className="w-4 h-4" />
            Buy Credits
          </Link>
          {token && (
            <>
              <Link to="/call-history" className="hover:text-gray-500 transition flex items-center gap-1.5">
                <History className="w-4 h-4" />
                History
              </Link>
              <Link to="/profile" className="hover:text-gray-500 transition flex items-center gap-1.5">
                <CircleUserRound className="w-4 h-4" />
                Profile
              </Link>
              <Link to="/support" className="hover:text-gray-500 transition flex items-center gap-1.5">
                <Mail className="w-4 h-4" />
                Support
              </Link>
            </>
          )}
          <Link to="/destinations" className="hover:text-gray-500 transition flex items-center gap-1.5">
              <Globe className="w-4 h-4" />
              Destinations
          </Link>
          <Link to="/faq" className="hover:text-gray-500 transition flex items-center gap-1.5">
            <MessageCircle className="w-4 h-4" />
            FAQ
          </Link>
        </div>

        {/* Right: Auth/Buy Credits links */}
        <div className="hidden lg:flex items-center space-x-4">
          {!token && (
            <>
              <Link to="/login" className="text-gray-900 hover:text-gray-500">Login</Link>
              <Link to="/register" className="text-gray-900 hover:text-gray-500">Register</Link>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="lg:hidden">
          <button onClick={toggleMenu} className="text-gray-900 hover:text-gray-500 focus:outline-none">
            {menuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="absolute left-0 right-0 mt-2 w-full bg-white border-t border-purple-700 z-40 flex flex-col items-center space-y-4 py-6 text-gray-900 text-base font-medium shadow-md">
          <Link to="/call" className="hover:text-gray-700 transition flex items-center gap-1.5">
            <Phone className="w-4 h-4" />
            Call
          </Link>
          <Link to="/buy-credits" className="hover:text-gray-700 transition flex items-center gap-1.5">
            <CreditCard className="w-4 h-4" />
            Buy Credits
          </Link>
          {!token && (
            <>
              <Link to="/faq" className="hover:text-gray-700 transition flex items-center gap-1.5">
                <MessageCircle className="w-4 h-4" />
                FAQ
              </Link>
              <Link to="/destinations" className="hover:text-gray-700 transition flex items-center gap-1.5">
                  <Globe className="w-4 h-4" />
                  Destinations
              </Link>
              <Link to="/login" className="hover:text-gray-700 transition">Login</Link>
              <Link to="/register" className="hover:text-gray-700 transition">Register</Link>
            </>
          )}
          {token && (
            <>
              <Link to="/call-history" className="hover:text-gray-700 transition flex items-center gap-1.5">
                <History className="w-4 h-4" />
                History
              </Link>
              <Link to="/profile" className="hover:text-gray-700 transition flex items-center gap-1.5">
                <CircleUserRound className="w-4 h-4" />
                Profile
              </Link>
              <Link to="/destinations" className="hover:text-gray-700 transition flex items-center gap-1.5">
                  <Globe className="w-4 h-4" />
                  Destinations
              </Link>
              <Link to="/support" className="hover:text-gray-700 transition flex items-center gap-1.5">
                <Mail className="w-4 h-4" />
                Support
              </Link>
              <Link to="/faq" className="hover:text-gray-700 transition flex items-center gap-1.5">
                <MessageCircle className="w-4 h-4" />
                FAQ
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
